/* sm-header — mobile drawer (drop-down + slide-in sub panels + accordion), cart icon count/shake.
   Desktop mega menu is pure CSS (:hover / :focus-within). Mirrors Manukora's new-header.js behaviour. */
(function () {
  // Locale-aware store root, per Shopify's guidance ("avoid hardcoding URLs"): "/" on the
  // English site, "/es/" on the Spanish one. Cart calls made from it return localized data
  // (Spanish titles, /es/ product links) and keep the shopper in their language.
  function storeRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function initHeader(header) {
    var burger = header.querySelector('.sm-header__burger');
    var drawer = header.querySelector('.sm-header__drawer');
    if (!burger || !drawer) return;
    var items = Array.prototype.slice.call(drawer.querySelectorAll('.sm-header__drawer-list > .sm-header__drawer-item'));

    function lock(on) {
      document.body.classList.toggle('sm-scroll-locked', on);
    }
    function isOpen() {
      return drawer.classList.contains('is-open');
    }
    function openDrawer() {
      drawer.classList.add('is-open');
      burger.classList.add('is-active');
      burger.setAttribute('aria-expanded', 'true');
      lock(true);
      // Manukora opens the first accordion (LEARN) with the menu
      var firstAcc = drawer.querySelector('.sm-header__drawer-item.has-accordion');
      if (firstAcc) {
        firstAcc.classList.add('is-open');
        var a = firstAcc.querySelector('[data-sm-acc]');
        if (a) a.setAttribute('aria-expanded', 'true');
      }
    }
    function finishClose() {
      drawer.classList.remove('is-open');
      burger.classList.remove('is-active');
      burger.setAttribute('aria-expanded', 'false');
      lock(false);
      items.forEach(function (li) {
        li.classList.remove('is-open');
        var a = li.querySelector('[aria-expanded]');
        if (a) a.setAttribute('aria-expanded', 'false');
      });
    }
    function closeDrawer() {
      var openSub = drawer.querySelector('.has-sub.is-open');
      if (openSub) {
        // slide the sub panel out first, then drop the drawer (like theirs)
        openSub.classList.remove('is-open');
        var sub = openSub.querySelector('.sm-header__sub');
        var done = false;
        var finish = function () {
          if (done) return;
          done = true;
          finishClose();
        };
        if (sub) {
          sub.addEventListener(
            'transitionend',
            function onEnd(e) {
              if (e.propertyName === 'transform') {
                sub.removeEventListener('transitionend', onEnd);
                finish();
              }
            }
          );
        }
        setTimeout(finish, 550);
      } else {
        finishClose();
      }
    }

    burger.addEventListener('click', function () {
      isOpen() ? closeDrawer() : openDrawer();
    });
    drawer.querySelectorAll('.sm-header__drawer-close').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        closeDrawer();
      });
    });
    drawer.querySelectorAll('.sm-header__back').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var li = btn.closest('.has-sub');
        if (li) {
          li.classList.remove('is-open');
          var a = li.querySelector(':scope > .sm-header__drawer-link');
          if (a) a.setAttribute('aria-expanded', 'false');
        }
      });
    });
    items.forEach(function (li) {
      var link = li.querySelector(':scope > .sm-header__drawer-link');
      if (li.classList.contains('has-sub')) {
        li.addEventListener('click', function (e) {
          if (e.target.closest('.sm-header__sub')) return; // clicks inside the panel are real links
          e.preventDefault();
          items.forEach(function (o) {
            if (o !== li && o.classList.contains('has-sub')) o.classList.remove('is-open'); // accordions stay as they were (Manukora keeps them independent)
          });
          var open = li.classList.toggle('is-open');
          if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      } else if (link && !li.classList.contains('has-accordion')) {
        // plain item: the arrow icon sits outside the <a>, so make the whole row navigate
        li.style.cursor = 'pointer';
        li.addEventListener('click', function (e) {
          if (e.target.closest('a, button')) return;
          window.location.href = link.getAttribute('href');
        });
      } else if (li.classList.contains('has-accordion') && link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          var open = li.classList.toggle('is-open');
          link.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !isOpen()) return;
      var openSub = drawer.querySelector('.has-sub.is-open');
      if (openSub) openSub.classList.remove('is-open');
      else closeDrawer();
    });
    // if the viewport grows past the mobile breakpoint while open, reset
    window.addEventListener('resize', function () {
      if (window.innerWidth > 800 && isOpen()) finishClose();
    });
  }

  /* ----- cart icon: count bubble + empty/filled swap + shake ----- */
  function setHidden(el, hide) {
    if (!el) return;
    if (hide) el.setAttribute('hidden', '');
    else el.removeAttribute('hidden');
  }
  function bagCount(cart) {
    if (!cart || !cart.items) return (cart && cart.item_count) || 0;
    var seen = {}, n = 0;
    cart.items.forEach(function (it) {
      var id = it.properties && it.properties._sm_bundle;
      if (id) { if (!seen[id]) { seen[id] = 1; n += 1; } }
      else n += it.quantity || 0;
    });
    return n;
  }
  function updateCartIcon(cart) {
    var n = bagCount(cart);
    document.querySelectorAll('[data-sm-cart-count]').forEach(function (c) {
      c.textContent = n;
      setHidden(c, n <= 0);
    });
    document.querySelectorAll('[data-sm-cart-empty]').forEach(function (c) {
      setHidden(c, n > 0);
    });
    document.querySelectorAll('[data-sm-cart-full]').forEach(function (c) {
      setHidden(c, n <= 0);
    });
    document.querySelectorAll('.sm-header__cart').forEach(function (a) {
      a.setAttribute('aria-label', 'Cart (' + n + ')');
    });
  }
  function shakeCart() {
    document.querySelectorAll('.sm-header__cart').forEach(function (el) {
      el.classList.remove('is-shaking');
      void el.offsetWidth;
      el.classList.add('is-shaking');
      setTimeout(function () {
        el.classList.remove('is-shaking');
      }, 1600);
    });
  }
  var fetching = null;
  function fetchCartIcon() {
    if (fetching) return fetching;
    fetching = fetch(storeRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(updateCartIcon)
      .catch(function () {})
      .finally(function () {
        fetching = null;
      });
    return fetching;
  }
  document.addEventListener('sm-cart:updated', function (e) {
    var d = e.detail || {};
    if (d.cart) updateCartIcon(d.cart);
    else fetchCartIcon();
    if (d.added) shakeCart();
  });
  document.addEventListener('cart:update', function () {
    fetchCartIcon();
  });

  function boot() {
    document.querySelectorAll('[data-sm-header]').forEach(function (h) {
      if (h.dataset.smInit) return;
      h.dataset.smInit = '1';
      initHeader(h);
    });
    fetchCartIcon();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
